var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.6667H4.66667C2 14.6667 1.33333 14.0001 1.33333 11.3334V10.0001C1.33333 7.33341 2 6.66675 4.66667 6.66675H11.3333C14 6.66675 14.6667 7.33341 14.6667 10.0001V11.3334C14.6667 14.0001 14 14.6667 11.3333 14.6667Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66659V5.33325C4 3.12659 4.66667 1.33325 8 1.33325C10.3333 1.33325 11.3333 1.33325 12 2.66659",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.3333C8.92048 12.3333 9.66667 11.5871 9.66667 10.6667C9.66667 9.74619 8.92048 9 8 9C7.07953 9 6.33333 9.74619 6.33333 10.6667C6.33333 11.5871 7.07953 12.3333 8 12.3333Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.2fb4b68f6123c551bf274100a07e7612.svg";
export { ForwardRef as ReactComponent };